// Breadcrumbs component for document and collection pages.

import React from 'react';
import { Link } from 'react-router';
import { cn } from '@/utilities/cn';
import type { BreadcrumbItem } from '@/content/lib/breadcrumbs';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  const showBreadcrumbs = items.length > 1;

  return (
    <nav
      aria-label={showBreadcrumbs ? 'Breadcrumb' : undefined}
      aria-hidden={showBreadcrumbs ? undefined : true}
      className={cn(
        'text-sm text-muted-foreground',
        !showBreadcrumbs && 'invisible pointer-events-none select-none'
      )}
    >
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-2">
            {index > 0 && <span aria-hidden="true">/</span>}
            {index === items.length - 1 ? (
              <span className="text-foreground">{item.label}</span>
            ) : (
              <Link to={item.path} className="hover:text-primary">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
